import { render, staticRenderFns } from "./RestorePasswordContact.vue?vue&type=template&id=bced7650&scoped=true"
import script from "./RestorePasswordContact.vue?vue&type=script&lang=js"
export * from "./RestorePasswordContact.vue?vue&type=script&lang=js"
import style0 from "./RestorePasswordContact.vue?vue&type=style&index=0&id=bced7650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced7650",
  null
  
)

export default component.exports